import React from 'react';

import { useSessionTokensState, useSessionTokensActions } from './SessionTokensContext';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import DeleteSessionTokenForm from './DeleteSessionTokenForm';

const DeleteSessionTokenModal = () => {
  const state = useSessionTokensState();
  const { closeDeleteSessionTokenModal } = useSessionTokensActions();

  return (
    <StandardModal
      isOpen={state?.deleteSessionTokenModalIsOpen}
      contentLabel="Delete Session Token"
      onRequestClose={() => {
        closeDeleteSessionTokenModal();
      }}
    >
      <DeleteSessionTokenForm />
    </StandardModal>
  );
};

export default DeleteSessionTokenModal;
